import { IDashboard } from '../../interfaces/dashboard/iDashboard'
import { IMemberProfileInfo } from '../../interfaces/dashboard/iMemberProfileInfo'
import { INonprofit } from "../../interfaces/dashboard/iNonprofit";
import { ITaskCard } from '../../interfaces/dashboard/iTaskCard';
import { IEvent } from '../../interfaces/iEvent';

export class Dashboard implements IDashboard {
    recommended: INonprofit[];
		member: IMemberProfileInfo;
		notifications: ITaskCard[];
		recommendedEvents: IEvent[];
		showWelcomeCard: boolean;
		countMember: number;

    constructor(dashboard: IDashboard = {} as IDashboard) {
        this.recommended = dashboard.recommended;
				this.member = dashboard.member;
				this.notifications = dashboard.notifications;
				this.recommendedEvents = dashboard.recommendedEvents;
				this.showWelcomeCard = !!dashboard.showWelcomeCard;
				this.countMember = dashboard.countMember;
	}
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/dashboard/dashboard.ts